const Events = {
  onAddToCartPress: 'onAddToCartPress',
  onRecommendationBackToShopPress: 'onRecommendationBackToShopPress',
  onFeedbackConfirm: 'onFeedbackConfirm',
  onPiReconstructionRequest: 'onPiReconstructionRequest',
};

export default Events;
